import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import TransportPriceList from '../../components/Entity/TransportPrice/List/List';
 
const TransportPricesPage = () => {
  return <Layout fullwidth={0}>
   
      <TransportPriceList></TransportPriceList>
     
  </Layout>;
}

export default TransportPricesPage;
